import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  accessTokenAtom,
  isAnonymousUserAtom,
  refreshTokenAtom,
} from "@/utils/atoms";

/*
 * This hook handles the redirect to the partner portal after the user has logged in.
 * For partner app, we simply redirect to the cockpit if authenticated.
 */
export const usePartnerLoginRedirect: () => boolean = () => {
  const [accessToken] = useAtom(accessTokenAtom);
  const [refreshToken] = useAtom(refreshTokenAtom);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const navigate = useNavigate();

  const authorized = !!accessToken;

  // This effect is triggered when the user is redirected back from the Oauth2 provider.
  // It fetches our auth tokens.
  useEffect(() => {
    if (!authorized) {
      setIsRedirecting(true);
      // For partner app, we don't use OAuth2 flow, so we just clear the code
      // and let the normal login flow handle authentication
      navigate("/welcome", { replace: true });
    }
  }, [authorized, navigate]);

  const [isAnonymousUser] = useAtom(isAnonymousUserAtom);

  useEffect(() => {
    setIsRedirecting(true);
    if (accessToken && refreshToken && !isAnonymousUser) {
      // For partner app, just redirect to cockpit if authenticated
      navigate("/portal/cockpit", { replace: true });
    }

    setIsRedirecting(false);
  }, [authorized, accessToken, isAnonymousUser, navigate, refreshToken]);

  return isRedirecting;
};
